<template>
  <div>
    <div class="question-text" v-html="getQuestionText"></div>
    <button type="button" class="previous" @click="prev">Previous</button>
    <button @click="save" class="active next">Save</button>
  </div>
</template>

<script>
import store from '@/store'
import { answers as answersDb } from '@/database';
import { v4 as uuidv4 } from 'uuid';

export default {
    name: 'end-save',

    props: {
      data: {
        required: true,
        type: Object
      }
    },

    methods: {
      save() {
        let answers = this.$parent.answers;
        let time = Date.now();
        let uid = uuidv4();

        answers.survey = this.$parent.survey;
        answers.dtstart = this.$parent.dtstart;
        answers.dtstop = time;

        answers.push({
          survey: this.$parent.survey,
          dtstart: this.$parent.dtstart,
          dtstop: time,
          synced: false,
          uuid: uid
        });

        answersDb.setItem(time, answers)
          .then( () => {
            store.dispatch('buildSurveys');
            console.log('trying to log the response');
            store.commit('setCount')
            this.$router.push({name:'dashboard'});
          })
          .catch((error) => {
            console.log(error);
          })
      },

      prev() {
        this.$emit('prev-question');
      },
    },

    computed: {
      getQuestionText() {
        const index = this.data.text.findIndex(t => t.lang == this.$parent.lang)
        return this.data.text[index].html;
      }
    }
}
</script>